// You can customize the template with the help of this file

//Template config options
const themeConfig = {
  app: {
    appName: 'ARG',
    appLogoImage: require('@src/assets/images/logo/logo.png').default,
    headRoute: '',
    baseURLs: {
      baseURL: 'https://targetslive.co/rozaana',
    },
    paymentURLs: {
      '': 'https://rozaana.pk/ondeman_services_live/appspayment/payuserbill.php',
      '/rozaana':
        'https://ivyinteractive.co/rozaana/appspayment/payuserbill.php',
      '/preLive':
        'https://rozaana.pk/ondeman_services_prelive/appspayment/payuserbill.php',
    },
    fbPath: 'meta',
    pixelId: '440853745065455',
    baseURL: 'https://targetslive.co/rozaana', // live
    // baseURL: 'https://rozaana.pk/apistestroz' // test
  },
  layout: {
    isRTL: false,
    skin: 'light', // light, dark, bordered, semi-dark
    type: 'vertical', // vertical, horizontal
    contentWidth: 'boxed', // full, boxed
    menu: {
      isHidden: false,
      isCollapsed: false,
    },
    navbar: {
      // ? For horizontal menu, navbar type will work for navMenu type
      type: 'floating', // static , sticky , floating, hidden
      backgroundColor: 'white', // BS color options [primary, success, etc]
    },
    footer: {
      type: 'static', // static, sticky, hidden
    },
    customizer: false,
    scrollTop: true, // Enable scroll to top button
    toastPosition: 'top-right', // top-left, top-center, top-right, bottom-left, bottom-center, bottom-right
  },
};

export default themeConfig;
